import { TableColumn, TableRow } from '@/components/Table/types';
import { Trans } from 'react-i18next';

export const nameColumnConfig = <T extends TableRow>(
  options?: Omit<TableColumn<T>, 'id' | 'label'>,
  label: 'name' | 'process' | 'workflow' | 'task' = 'name',
): TableColumn<T> => ({
  id: 'name',
  label: <Trans i18nKey={label} />,
  render: (value) => (
    <div className="overflow-hidden text-ellipsis font-black">{value}</div>
  ),
  acessorKey: 'name',
  sortable: true,
  align: 'left',
  alignHeader: 'left',
  className: 'max-w-[20vw] w-[20vw]',
  ...options,
});
